import { CatharsisArgs, getInvalidationHandler, MegaStore } from '@wix/thunderbolt-catharsis'

export const createCatharsisArgs = (
	catharsisMegaStore: MegaStore,
	componentNodes: CatharsisArgs['extensions']['componentNodes'],
	dataNodes: CatharsisArgs['extensions']['dataNodes'],
	schemas: CatharsisArgs['extensions']['schemas']
): CatharsisArgs => {
	const onInvalidation = getInvalidationHandler(catharsisMegaStore)

	return {
		onInvalidation,
		extensions: { componentNodes, schemas, dataNodes },
		structureStore: catharsisMegaStore.getChildStore('structure'),
	}
}
